module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-4.f1901fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-4.jpg
// module id = JLBa
// module chunks = 1